import FormattedMessage from 'I18n/components/FormattedMessage';
import { CreditTile } from './CreditTile';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreditTileAvailable = ({
  credits,
  hasLowCredits,
  isLoading
}) => /*#__PURE__*/_jsxs(CreditTile, {
  isLoading: isLoading,
  children: [/*#__PURE__*/_jsx(CreditTile.Count, {
    hasLowCredits: hasLowCredits,
    children: /*#__PURE__*/_jsx(FormattedNumber, {
      value: credits
    })
  }), /*#__PURE__*/_jsx(CreditTile.Label, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "enrichmentCredits.availableLabel"
    })
  })]
});